<template>
<!-- 区域的选择 1. 下拉选择 2点击选择单选, 3多选 -->
  <div class="w-h-100 change-area" :class="{'company-user': !showCompany}">
    <div v-if="areaType==1">
      <el-select v-if="showCompany" filterable v-model="enterpriseId"
                 size="small"
                 class="el-input-300"
                 placeholder="请选择企业">
        <el-option v-for="item in companyList"
                   :key="item.id"
                   :label="item.enterpriseName"
                   :value="item.id">
        </el-option>
      </el-select>
      <el-select filterable clearable size="small" :class="className" v-model="areaId" placeholder="请选择区域">
        <el-option
          v-for="item in areaList"
          :key="item.id"
          :label="item.regionName"
          :value="item.id">
        </el-option>
      </el-select>
    </div>
    <!-- 单选 -->
    <div class="w-h-100" v-else-if="areaType==2">
      <!-- <changeProject />-->
      <el-select v-if="showCompany" filterable v-model="enterpriseId"
                 size="small"
                 class="el-input-p-100"
                 placeholder="请选择企业">
        <el-option v-for="item in companyList"
                   :key="item.id"
                   :label="item.enterpriseName"
                   :value="item.id">
        </el-option>
      </el-select>
        <div class="clearfix search-input" style="margin-top: 10px">
          <div class="w-h-100">
            <el-input class="el-input-p-100"
                      clearable
                      @clear="searchLeftBtn"
                      size="small"
                      placeholder="请输入关键字查询区域"
                      v-model="inputName">
              <el-button slot="append" @click="searchLeftBtn"
                         icon="el-icon-search"></el-button>
            </el-input>
          </div>
        </div>
        <div class="page-part">
          <div class="page-area">
            <ul>
              <li :class="[{'is-active':areaId==item.id}]"
                  v-for="(item, index) in areaList"
                  :key="index"
                  @click="areaId=item.id">{{item.regionName}}</li>
            </ul>
            <el-empty v-show="areaList.length==0" description="暂无区域数据"></el-empty>
          </div>
          <div class="page-paginnation" v-show="areaList.length>0">
            <pagination :totalRecords="totalRecordsLeft"
                        :pageSize="pageSizeLeft"
                        :pageIndex="pageIndexLeft"
                        layout="total, prev, pager, next"
                        @changePageNumber="changePageNumberLeft"></pagination>
          </div>
        </div>
    </div>
    <!-- 多选 -->
    <div class="w-h-100" v-else-if="areaType==3">
      <el-select v-if="showCompany" filterable v-model="enterpriseId"
                 size="small"
                 class="el-input-p-100"
                 placeholder="请选择企业">
        <el-option v-for="item in companyList"
                   :key="item.id"
                   :label="item.enterpriseName"
                   :value="item.id">
        </el-option>
      </el-select>

      <div class="clearfix search-input" style="margin-top: 10px">
          <div class="w-h-100">
            <el-input class="el-input-p-100"
                      clearable
                      @clear="searchLeftBtn"
                      size="small"
                      placeholder="请输入关键字查询区域"
                      v-model="inputName">
              <el-button slot="append" @click="searchLeftBtn"
                         icon="el-icon-search"></el-button>
            </el-input>
          </div>
        </div>
        <div class="page-part">
          <div class="area-checked">
            <el-empty v-show="areaList.length==0" description="暂无区域数据"></el-empty>
            <el-checkbox v-show="areaList.length>0" :indeterminate="isIndeterminate"
                         v-model="checkAll"
                         @change="handleCheckAllChange">全选</el-checkbox>
            <div style="margin: 10px 0;"></div>
            <el-checkbox-group v-model="checkedArea"
                               @change="handleCheckedChange">
              <div class="checkbox-one"
                   v-for="(item, key) in areaList"
                   :key="key">
                <el-checkbox :label="item.id">
                  <!-- <span class="region-name" :class="{'is-checked': checkedArea.includes(item.id)}">{{item.regionName}}</span> -->
                </el-checkbox>
                <span class="region-name" :class="{'is-checked': checkedArea.includes(item.id)}">{{item.regionName}}</span>
              </div>
            </el-checkbox-group>
            <!-- <ul>
              <li :class="[{'is-active':areaId==item.code}]"
                  v-for="(item, index) in areaList"
                  :key="index"
                  @click="areaId=item.code">{{item.name}}</li>
            </ul> -->
          </div>
          <div class="page-paginnation" v-show="areaList.length>0">
            <pagination :totalRecords="totalRecordsLeft"
                        :pageSize="pageSizeLeft"
                        :pageIndex="pageIndexLeft"
                        layout="total, prev, pager, next"
                        @changePageNumber="changePageNumberLeft"></pagination>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import {
  getRegionList,
  getProjectList // 企业分页列表
} from '@/api/common'
import {
  regionList // 区域列表
} from '@/api/setting'
export default {
  props: {
    areaType: { // 1 下拉 2单选 3多选
      type: Number
    },
    showFirst: {
      type: Boolean,
      default: true
    },
    className: {
      type: String,
      default: 'el-input-300'
    },
    companyId: {
      default: ''
    },
    formType: { // 2需要使用regionList接口
      type: Number
    }
  },
  data () {
    return {
      isFirstPage: true,
      enterpriseId: '',
      companyList: [],
      areaId: '',
      areaList: [],
      inputName: '',
      regionName: '',
      totalRecordsLeft: 0,
      pageSizeLeft: 20,
      pageIndexLeft: 1,
      isIndeterminate: false,
      checkAll: false,
      checkedArea: []
      // showCompany: true
    }
  },
  computed: {
    projectId () {
      return this.$store.getters.projectId
    },
    isProjectUser () {
      return this.$store.getters.isProjectUser
    },
    showCompany () {
      // let flag = true
      // if (this.isProjectUser) {
      //   flag = false
      // } else {
      //   flag = !this.companyId
      // }
      // 非企业账号展示 && 没有companyId
      return !this.isProjectUser && !this.companyId
    }
  },
  watch: {
    enterpriseId (newVal) {
      if (newVal) {
        this.areaId = ''
        this.regionList()
      }
    },
    projectId (n) {
      if (n) {
        this.enterpriseId = n
      }
    },
    showCompany (n) {
      // console.log(123, n)
      this.renderList()
    },
    areaId (newVal) {
      this.$emit('changeAreaId', {
        enterpriseId: this.enterpriseId,
        areaId: newVal
      })
    },
    checkedArea: {
      handler (newVal, oldVal) {
        this.$emit('changeAreaIds', {
          enterpriseId: this.enterpriseId,
          areaIds: newVal
        })
      },
      deep: true
    },
    pageIndexLeft: {
      handler (newVal, oldVal) {
        this.regionList()
      },
      deep: true
    }
  },
  created () {
    // console.log(this.showCompany, 444)
    this.renderList()
  },
  methods: {
    renderList () {
      // console.log(333, this.isProjectUser)
      if (this.showCompany) {
        this.getProjectList()
      } else {
        this.enterpriseId = this.projectId
        this.regionList()
      }
    },
    async getProjectList () {
      let params = {
        enterpriseName: '',
        orderByColumn: '',
        isAsc: '',
        pageIndex: 1,
        pageSize: 99999
      }
      let res = await getProjectList(params)
      if (res) {
        this.companyList = res.data || []
        if (this.companyList.length > 0) {
          if (this.projectId) {
            this.enterpriseId = this.projectId
          } else {
            this.enterpriseId = this.companyList[0].id
          }
        }
      }
    },
    // 区域列表
    async regionList () {
      let params = {
        pageSize: this.areaType === 1 ? 10000 : this.pageSizeLeft,
        pageIndex: this.pageIndexLeft,
        regionName: this.regionName,
        enterpriseId: this.enterpriseId
      }
      // let resData = await regionList(params)
      let resData = await getRegionList(params)
      if (resData) {
        this.totalRecordsLeft = resData.totalRecords
        this.areaList = resData.data || []
        if (this.areaList.length > 0 && this.showFirst) {
          if (this.areaType === 3) {
            let checkedArr = this.areaList.slice(0, 10)
            this.checkedArea = checkedArr.map(item => item.id)
            this.handleCheckedChange(this.checkedArea)
          } else {
            this.areaId = this.areaList[0].id
          }
        }
        if (this.areaList.length === 0) {
          if (this.areaType === 3) {
            this.checkedArea = []
          } else {
            this.areaId = ''
          }
        }
      }
    },
    searchLeftBtn () {
      this.regionName = this.inputName
      this.regionList()
    },
    // 页码跳转
    changePageNumberLeft (val) {
      this.pageIndexLeft = val
    },
    // 权限
    handleCheckAllChange (val) {
      let checkedAll = this.areaList.map(item => item.id)
      this.checkedArea = val ? checkedAll : []
      this.isIndeterminate = false
    },
    // 单选
    handleCheckedChange (value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.areaList.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.areaList.length
    }
  }
}
</script>

<style lang="scss" scoped>
.change-area{
  .page-part{
    height: calc(100% - 80px) !important;
    .page-area{
      max-height: calc(100% - 65px) !important;
      overflow-y: auto;
      overflow-x: hidden;
    }
    .area-checked {
      max-height: calc(100% - 65px) !important;
      overflow-y: auto;
      overflow-x: hidden;
      padding-top: 10px;
      /deep/ .el-checkbox-group {
        .checkbox-one {
          width: 100%;
          line-height: 24px;
        }
        .el-checkbox {
          // width: 100%;
          // line-height: 30px;
        }
        .el-checkbox__label{
          display: none;
          // word-break: break-all;
          // width: calc(100% - 40px);
        }
        .region-name{
          font-size: 14px;
          margin-left: 4px;
          &.is-checked{
            color: #3377ff;
          }
        }
      }
    }
  }
}
.company-user{
  .page-part{
    height: calc(100% - 40px) !important;
  }
}
</style>
